import { Injectable } from '@angular/core';

@Injectable()
export class TabsetConfig {
  /** provides default navigation context class: 'tabs' or 'pills' */
  type = 'tabs';
}



// WEBPACK FOOTER //
// ./.tmp/tabs/tabset.config.ts